import { Cross } from "lucide-react";

import { Button } from "@/components/ui/button";
import { ISectionProps } from "@/interfaces/section-props.interface";

const HeroComponent = ({ fnOnScrollToOne, fnOnScrollToTwo }: ISectionProps) => {
  return (
    <>
      <section className="flex justify-center content-center">
        <div style={{ maxWidth: "1920px" }}>
          <img src="/images/banner.png" alt="Aconselhamento Bíblico 2025" />
        </div>
      </section>
      <section className="section hero-section relative py-12 px-4 text-center overflow-hidden custom-color-03">
        <div className="absolute inset-0 opacity-10">
          <Cross className="absolute top-10 left-10 w-8 h-8 custom-color-02" />
          <Cross className="absolute top-20 right-20 w-6 h-6 custom-color-02" />
          <Cross className="absolute bottom-20 left-20 w-10 h-10 custom-color-02" />
          <Cross className="absolute bottom-10 right-10 w-7 h-7 custom-color-02" />
        </div>
        <div className="max-w-4xl mx-auto relative z-10">
          <div className="mb-8">
            <h1 className="text-5xl md:text-5xl font-bold mb-4 leading-tight">
              EM CRISTO VOCÊ PODE MUDAR
            </h1>
            <h2 className="text-2xl md:text-3xl mb-8 font-light">
              Congresso de Aconselhamento Bíblico{" "}
              <span className="text-2xl font-semibold custom-color-04">
                Vida&Piedade 2025
              </span>
            </h2>
          </div>

          <div
            id="section1"
            className="bg-white/90 backdrop-blur-sm rounded-2xl p-8 mb-12 shadow-lg"
          >
            <p className="text-lg leading-relaxed mb-6">
              Um convite à transformação real fundamentada na suficiência das
              Escrituras
            </p>
            <p className="leading-relaxed">
              Se você deseja aconselhar, cuidar e servir pessoas com segurança
              bíblica diante dos desafios emocionais e espirituais do nosso
              tempo, este congresso foi cuidadosamente planejado para você. Aqui
              você encontrará ferramentas sólidas, conteúdo relevante e um
              ambiente de aprendizado comprometido com a centralidade do
              Evangelho.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              size="lg"
              className="px-8 py-4 text-lg rounded-full text-white font-semibold cursor-pointer hover:opacity-90 custom-bg-color-04"
              onClick={fnOnScrollToOne}
            >
              Quero participar
            </Button>
            <Button
              variant="outline"
              size="lg"
              className="px-8 py-4 text-lg rounded-full font-semibold cursor-pointer bg-white/90 custom-border-color-03"
              onClick={fnOnScrollToTwo}
            >
              Saiba mais
            </Button>
          </div>
        </div>
      </section>
      <section>
        <div>
          <p className="w-full italic text-center text-[7px] sm:text-[14px] md:text-base p-[4px] md:p-3 text-white custom-bg-color-03">
            ...pelo seu divino poder, nos têm sido doadas todas as coisas que
            conduzem à vida e à piedade...{" "}
            <strong className="custom-color-05">2 Pe 1.3a</strong>
          </p>
        </div>
      </section>
    </>
  );
};

export default HeroComponent;
